import React from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import ReactPlayer from 'react-player';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

const VideoDialog = observer(
  ({
    source,
    onClose,
  }: {
    source: string;
    onClose: () => void;
  }): JSX.Element => {
    const close = (): void => {
      onClose();
    };

    return (
      <Dialog maxWidth="md" open onClose={close}>
        <DialogTitle>Video Player</DialogTitle>
        <Box>
          <ReactPlayer url={source} />
          {source}
        </Box>
      </Dialog>
    );
  },
);

export default VideoDialog;
